__turbopack_context__.v({
  "darkText": "egPW1G_darkText",
  "lightText": "egPW1G_lightText",
});
